"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _usePortal = _interopRequireDefault(require("./usePortal"));
const Portal = _react.default.memo(({
  id,
  children
}) => {
  const target = (0, _usePortal.default)(id);
  return (0, _reactDom.createPortal)(children, target);
});
Portal.propTypes = {
  id: _propTypes.default.string,
  children: _propTypes.default.node
};
var _default = exports.default = Portal;